export enum NichoEstabelecimentoEnum {
  BELEZA_ESTETICA = 'BELEZA_ESTETICA',
  SAUDE_BEM_ESTAR = 'SAUDE_BEM_ESTAR',
  FITNESS_ESPORTES = 'FITNESS_ESPORTES',
  PET_CARE = 'PET_CARE',
  CONSULTORIA_SERVICOS = 'CONSULTORIA_SERVICOS',
  ESTUDIO_ARTE = 'ESTUDIO_ARTE',
  SERVICOS_TECNICOS = 'SERVICOS_TECNICOS',
  INFORMATICA = 'INFORMATICA',
  AUTOMOTIVO = 'AUTOMOTIVO',
}

export const NichoEstabelecimentoOptions = [
  { label: 'Beleza & Estética (Barbearia, Salão, Estética)', value: NichoEstabelecimentoEnum.BELEZA_ESTETICA },
  { label: 'Saúde & Bem-Estar (Clínicas, Médicos, Consultórios)', value: NichoEstabelecimentoEnum.SAUDE_BEM_ESTAR },
  { label: 'Fitness & Studios (Pilates, Personal, Crossfit)', value: NichoEstabelecimentoEnum.FITNESS_ESPORTES },
  { label: 'Pet & Veterinária (Petshops, Grooming, Vets)', value: NichoEstabelecimentoEnum.PET_CARE },
  { label: 'Consultoria & Serviços (Advocacia, Contabilidade)', value: NichoEstabelecimentoEnum.CONSULTORIA_SERVICOS },
  { label: 'Arte & Estúdio (Tatuagem, Piercing, Fotografia)', value: NichoEstabelecimentoEnum.ESTUDIO_ARTE },
  { label: 'Serviços Técnicos & Manutenção (Pintor, Eletricista, Encanador)', value: NichoEstabelecimentoEnum.SERVICOS_TECNICOS },
  { label: 'Informática & Assistência Técnica (Computadores, Notebooks)', value: NichoEstabelecimentoEnum.INFORMATICA },
  { label: 'Oficina Automotiva (Mecânica, Funilaria, Auto Center)', value: NichoEstabelecimentoEnum.AUTOMOTIVO },
];
